export interface MultidimensionalAllocationLOV {
    dataSourceTypes: string[];
    currencyCodes: string[];
    periods: string[];
    currencyConversionTypes: string[]
}

export const getEmptyLOVs = function (): MultidimensionalAllocationLOV {
    return {
        dataSourceTypes: [],
        currencyCodes: [],
        periods: [],
        currencyConversionTypes: [],
    };
}